<template lang="html">
  <div id="about-us-page-v3">

    <section class="placed-backg banner-section">
      <div class="container">
        <div class="col-12 col-s-title">
          <h2 class="title">Nosotros</h2>
        </div>
      </div>
    </section>

    <section class="container oversized-container main-section">
      <div class="row row-content">
        <div class="col-lg-4 col-info">
          <p class="icon">
            <img src="public/images/pages/about-us/icon-1.png" alt="Misión">
          </p>

          <h4 class="title">Misión</h4>
          <p>
            Brindar soluciones integrales en productos y servicios de ferretería y de construcción excediendo las expectativas de empresas constructoras y público en general.
          </p>
        </div>

        <div class="col-lg-4 col-info">
          <p class="icon">
            <img src="public/images/pages/about-us/icon-2.png" alt="Visión">
          </p>

          <h4 class="title">Visión</h4>
          <p>
            Ser la empresa líder en el ramo ferretero y de construcción a nivel regional abriendo nuevos mercados comprometidos con el crecimiento y desarrollo sustentable.
          </p>
        </div>

        <div class="col-lg-4 col-info">
          <p class="icon">
            <img src="public/images/pages/about-us/icon-3.png" alt="Nuestros valores">
          </p>

          <h4 class="title">Nuestros valores</h4>
          <ul>
            <li>Servicio</li>
            <li>Honestidad</li>
            <li>Lealtad</li>
            <li>Responsabilidad</li>
            <li>Trabajo en equipo</li>
          </ul>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
      image: ''
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/api/nosotros')).then((response)=>{
        this.content = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
